import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import {
  Input,
  Button,
  FormFeedback,
  FormGroup,
  Label,
  InputGroup
} from "reactstrap";
import { connect } from "react-redux";
import Message from "../../CommonData/Data/Message.js";
import {
  changePassword,
  changePasswordForm
} from "../../store/actions.js";

const ChangePassword = (props) => {

  const { handleClose, errorMessage, passwordForm } = props;
  const { errors } = passwordForm || {};
  const [currentPassword, setCurrentPassword] = useState(true);
  const [newPassword, setNewPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState(true);

  useEffect(() => {
    props.changePasswordForm({
      errors: {}
    });
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [])

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    props.changePasswordForm(
      {
        ...props.passwordForm,
        [name]: value,
        errors: {
          ...props.passwordForm.errors,
          [name]: null,
        }
      }
    );
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    const { passwordForm } = props;
    const { currentPassword, newPassword, confirmNewPassword } = passwordForm || {};

    let currentErrors = {};

    if (!currentPassword) {
      currentErrors.currentPassword = "Current password is required";
    }
    if (!newPassword) {
      currentErrors.newPassword = "New password is required";
    }
    if (!confirmNewPassword) {
      currentErrors.confirmNewPassword = "Confirm password is required";
    }
    props.changePasswordForm(
      {
        ...props.passwordForm,
        errors: currentErrors
      }
    );

    if (Object.keys(currentErrors).length === 0) {
      props.changePassword();
    }
  };

  return (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <form className="mb-3" name="formChangePassword" onSubmit={handleChangePassword}>
        <FormGroup>
          <Label>Current Password<span className="text-danger">*</span></Label>
          <InputGroup>
            <Input
              autoFocus
              className={errors && errors.currentPassword ? "border-end-0" : 'border-end-0 border-secondary'}
              type={currentPassword ? "password" : "text"}
              name="currentPassword"
              placeholder="Enter current password"
              onChange={validateOnChange}
              invalid={errors && errors.currentPassword}
            />
            <Button
              className={errors && errors.currentPassword ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
              color='white'
              onClick={() => setCurrentPassword(!currentPassword)}
            >
              {currentPassword ?
                <i className="fas fa-eye text-secondary"></i>
                :
                <i class="fas fa-eye-slash text-secondary"></i>
              }
            </Button>
            <FormFeedback>{errors && errors.currentPassword}</FormFeedback>
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label >New Password<span className="text-danger">*</span></Label>
          <InputGroup><Input
            className={errors && errors.newPassword ? "border-end-0" : 'border-end-0 border-secondary'}
            type={newPassword ? "password" : "text"}
            name="newPassword"
            placeholder="Enter new password"
            onChange={validateOnChange}
            invalid={errors && errors.newPassword}
          />
            <Button
              className={errors && errors.newPassword ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
              color='white'
              onClick={() => setNewPassword(!newPassword)}
            >
              {newPassword ?
                <i className="fas fa-eye text-secondary"></i>
                :
                <i class="fas fa-eye-slash text-secondary"></i>
              }
            </Button>
            <FormFeedback>{errors && errors.newPassword}</FormFeedback>
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>Confirm Password<span className="text-danger">*</span></Label>
          <InputGroup>
            <Input
              className={errors && errors.confirmNewPassword ? "border-end-0" : 'border-end-0 border-secondary'}
              type={confirmPassword ? "password" : "text"}
              name="confirmNewPassword"
              placeholder="Enter confirm password"
              onChange={validateOnChange}
              invalid={errors && errors.confirmNewPassword}
            />
            <Button
              className={errors && errors.confirmNewPassword ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
              color='white'
              onClick={() => setConfirmPassword(!confirmPassword)}
            >
              {confirmPassword ?
                <i className="fas fa-eye text-secondary"></i>
                :
                <i class="fas fa-eye-slash text-secondary"></i>
              }
            </Button>
            <FormFeedback>{errors && errors.confirmNewPassword}</FormFeedback>
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Button
            type="submit"
            className='me-4'
            color="primary"
            onClick={handleChangePassword}
          >Submit
          </Button>
          <Button
            color="danger"
            onClick={handleClose}
          >Cancel
          </Button>
        </FormGroup>
      </form>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  passwordForm: state.userdetails.passwordForm,
  isPending: state.userdetails.isChangePasswordPending,
  errorMessage: state.userdetails.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  changePasswordForm: (passwordForm) => dispatch(changePasswordForm(passwordForm)),
  changePassword: () => dispatch(changePassword()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
